// used in sidebar only?
<template>
<div class="tw-text-sm font-normal">
  <template v-for="(value,$index) in field.datahash.options.values">
    <checkbox-display-one v-bind="$props" :value="value" :index="$index" />
  </template>
</div>
</template>
<script>
import CheckboxDisplayOne from './checkbox_display_one.vue';
export default {
  components: {CheckboxDisplayOne},
  props: ['field', 'form_result'],
}
</script>